export default function SpecTable({ specs }) {
  const entries = Object.entries(specs || {});
  return (
    <div className="overflow-x-auto spec-scroll" data-testid="spec-table">
      <table className="w-full text-sm border border-zinc-200">
        <tbody>
          {entries.map(([k, v], i) => (
            <tr key={k} className={i % 2 === 0 ? "bg-white" : "bg-bone"}>
              <th scope="row" className="text-left font-medium text-zinc-500 px-4 py-3 border-b border-zinc-200 w-1/2 align-top">
                {k}
              </th>
              <td className={`px-4 py-3 border-b border-zinc-200 text-ink ${v === "See datasheet" ? "text-zinc-400 italic" : "font-medium"}`}>
                {v}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
